import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>DevOps Training in Pune</h1>
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/devops.png")} alt="" />
          </div>
          <div className="heading">
            <h3>DevOps Training Course</h3>
            <p>
              DevOps is the union of people, process and products to enable the
              continuous delivery of value to end users. It aims to create a
              culture and environment where building, testing, and releasing
              software can happen rapidly, frequently, and more reliably, so you
              can innovate like a startup and scale for the enterprise.
              <br />
              Our DevOps Training is designed keeping in mind the latest market
              trend. This course will provide you with the in-depth knowledge of
              various DevOps tools including Basic linux, Git, Jenkins, Puppet,
              Ansible, Docker, Kubernetes and Nagios. This training is
              completely hands-on oriented and designed in a way that will help
              you in becoming a certified practitioner by providing you with an
              intensified training for the best practices about Continuous
              Development, Continuous Integration, Continuous Testing,
              Configuration Management, Continuous Deployment and finally
              Continuous Monitoring of the software throughout its development
              life cycle.
            </p>

            <h3>Best Training Institute in Pune</h3>
            <br />
            <h3>Course Duration: 3 Months</h3>
            <br />
            <h3>Course Syllabus:</h3>
            <br />
            {/*  */}
            <h4>1.Basic Linux</h4>
            <ul>
              <li>Unix Fundamentals </li>
              <li>User Administration </li>
              <li>Permissions </li>
              <li>Process Management </li>
              <li>Log Management </li>
              <li>Software Management </li>
              <li>Networking </li>
              <li>Virtualization on RHEL7</li>
            </ul>
            {/*  */}
            <h4>2.GIT</h4>
            <ul>
              <li>Introduction</li>
              <li>Version Control System Overview </li>
              <li>Installation </li>
              <li>Workflow </li>
              <li>Starting with GIT </li>
              <li>Setting up git repository </li>
              <li>Git remote repository </li>
              <li>Multiple Version </li>
              <li>Committing changes in Git </li>
              <li>Reverting changes in git repository </li>
              <li>Soft reset </li>
              <li>Hard reset </li>
              <li>Clone </li>
              <li>Git repo inspection </li>
              <li>Pushing to GitHub </li>
              <li>GitHub through SSH </li>
              <li>Git Branching </li>
              <li>Git Merging techniques </li>
            </ul>
            {/*  */}
            <h4>3.Docker</h4>
            <ul>
              <li>Getting Started With Containers </li>
              <li>Container Architecture </li>
              <li>Provisioning a Database Server</li>
              <li>Working with Containers </li>
              <li>Managing the Life Cycle of Containers </li>
              <li>Attaching Persistent Storage </li>
              <li>Using Data Containers </li>
              <li>Persisting a MySQL Database with Data Container </li>
              <li>Accessing Container Resources </li>
              <li>Loading the Database </li>
              <li>Managing Images </li>
              <li>Working With Registries </li>
              <li>Examples on Working With Registries </li>
              <li>Transferring Images </li>
              <li>Creating Simple Images </li>
              <li>Creating a Custom Apache Container Image </li>
              <li>Creating Custom Images </li>
              <li>Creating a Basic Apache Container Image </li>
              <li>Creating a Basic Apache Container Image</li>
              <li>Controlling the Container Environment</li>
              <li>Making a Container Image More Flexible </li>
              <li>Building an Application Container Image </li>
              <li>Using Triggers and Resources </li>
              <li>Designing Container Images for Application Deployment </li>
              <li>Reusing Existing Dockerfiles </li>
              <li>Designing a Container Image for the To Do List Application – PHP </li>
              <li>Docker swarm and Docker compose </li>
              <li>Creating docker clusters using docker swarm </li>
              <li>launching containers using docker compose </li>
            </ul>
            {/*  */}
            <h4>
            4.Jenkins
            </h4>
            <ul>
              <li>Jenkins Overview </li>
              <li>What is Jenkins </li>
              <li>What is continuous integration? </li>
              <li>Installation </li>
              <li>Tomcat Setup </li>
              <li>GIT </li>
              <li>Configuration </li>
              <li>Management (Configure System , Plugins , System information) </li>
              <li>Setup Build Jobs </li>
              <li>Unit Testing </li>
              <li>Automated Testing </li>
              <li>Reporting </li>
              <li>Code Analytics </li>
              <li>Distributed Builds </li>
              <li>Automated Deployment </li>
              <li>Metrics & Trends </li>
              <li>Server Maintenance (Backup jenkins Home ) </li>
              <li>Continuous Deployment </li>
              <li>Managing Plugins (Uninstalling Plugins ,Installing another Version of a Plugin) </li>
              <li>Security </li>
              <li>Backup Plugin </li>
              <li>Remote Testing </li>
            </ul>
            {/*  */}
            <h4>
            5.Ansible
            </h4>
            <ul>
              <li>Introduction to Ansible </li>
              <li>Deploying Ansible </li>
              <li>Implementing Playbooks </li>
              <li>Managing Variables and inclusions </li>
              <li>Implementing Task Control </li>
              <li>Implementing Jinja2 templates </li>
              <li>Implementing Roles </li>
              <li>Optimizing Ansible </li>
              <li>Implementing Ansible Vault </li>
            </ul>
            {/*  */}
            <h4>
            6.NagiOS XI
            </h4>
            <ul>
              <li>Nagios XI Installation </li>
              <li>Nagios XI Basics </li>
              <li>Monitoring Linux System </li>
              <li>Monitoring Windows System </li>
              <li>Monitoring Network Devices </li>
              <li>Performance Charts, Graphs and Dashboards </li>
              <li>Alerts, Notifications and Escalations </li>
              <li>Additional Tools (BBMap ,Minemap , Network Status Map) </li>
              <li>Reports </li>
              <li>Backup and Restore </li>
              <li>Enterprise Feature Overview </li>
              <li>Nagios Core Overview </li>
            </ul>
            {/*  */}
            <h4>
            7.AWS
            </h4>
            <ul>
              <li>Introduction </li>
              <li>IAM </li>
              <li>EC2 </li>
              <li>EBS </li>
              <li>Elastic Load Balancer </li>
              <li>RDS </li>
              <li>Route 53 </li>
              <li>VPC </li>
              <li>Lambda </li>
              <li>Cloud Watch </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
